import { HoverEffectGroup } from '@repo/ui/aceternity/card-hover-effect'
import { SidebarLink, useSidebar } from '@repo/ui/aceternity/sidebar'
import { useIsMobile } from '@repo/ui/hooks/use-mobile'
import { Link, type LinkProps } from '@tanstack/react-router'
import { Handshake, LayoutDashboard, Sheet } from 'lucide-react'
import type { ReactElement } from 'react'
import { useTranslation } from '@/lib/i18n'

function AdminNavGroups() {
	const { t } = useTranslation()
	const { setOpen } = useSidebar()
	const isMobile = useIsMobile()

	// On mobile the menu is a full-screen sheet: leave it once a page is picked.
	const handleNavigate = () => {
		if (isMobile) {
			setOpen(false)
		}
	}

	const links: {
		icon: ReactElement
		label: string
		to: LinkProps['to']
		exact?: boolean
	}[] = [
		{
			icon: <LayoutDashboard />,
			label: t('admin:home.page_title'),
			to: '/',
			exact: true
		},
		{ icon: <Sheet />, label: t('po:page_title'), to: '/documents' },
		{
			icon: <Handshake />,
			label: t('esclusive:page_title'),
			to: '/esclusive'
		}
	]

	return (
		<HoverEffectGroup className='flex flex-col gap-1'>
			{links.map((link) => (
				<SidebarLink
					className='data-[status=active]:bg-background data-[status=active]:font-medium data-[status=active]:text-foreground data-[status=active]:shadow-[0_0_0_1px_var(--sidebar-border),0_1px_2px_oklch(0.3_0.02_55/0.08)] data-[status=active]:[&_svg]:text-primary'
					icon={link.icon}
					key={link.label}
					label={link.label}
					render={
						<Link
							activeOptions={{ exact: link.exact ?? false }}
							onClick={handleNavigate}
							to={link.to}
						/>
					}
				/>
			))}
		</HoverEffectGroup>
	)
}

export { AdminNavGroups }
